import webSocket from 'services/api/webSocket'

import { OrderActionType } from './actions'
import * as AT from './actionTypes'
import { LiveOrderType, MarginCallDetails, MarginOrderDetails, Position } from './types'

export type OrderStateType = {
  activePosition?: Position
  live: Array<LiveOrderType>
  marginCallDetails?: MarginCallDetails
  marginOrderDetails?: MarginOrderDetails
  positions: Array<Position>
  snapshotReceived: boolean
  subscribed?: boolean
}

const initialState: OrderStateType = {
  live: [],
  positions: [],
  snapshotReceived: false
}

const parseOrder = (order: LiveOrderType): LiveOrderType => {
  if (order.ordType === webSocket.order.type.MARKET)
    return {
      ...order,
      price: order.avgPx!
    }
  return order
}

const order = (state: OrderStateType = initialState, action: OrderActionType): OrderStateType => {
  switch (action.type) {
    case AT.ADD: {
      return {
        ...state,
        live: [...state.live, action.payload.order],
        subscribed: state.subscribed
      }
    }

    case AT.RESET: {
      return initialState
    }

    case AT.SET_SNAPSHOT: {
      return {
        live: action.payload.orders.filter((order) => order.clOrdID).map(parseOrder),
        positions: action.payload.positions,
        snapshotReceived: true,
        subscribed: state.subscribed
      }
    }

    case AT.SET_SUBSCRIBED: {
      return {
        live: initialState.live,
        positions: initialState.positions,
        snapshotReceived: false,
        subscribed: true
      }
    }

    case AT.SET_UPDATE: {
      const { payload } = action
      return {
        ...state,
        live: [
          ...state.live.filter((order) => order.clOrdID !== payload.order.clOrdID),
          parseOrder(action.payload.order)
        ],
        subscribed: state.subscribed
      }
    }

    case AT.SET_REJECTED: {
      const { payload } = action

      const order = state.live.find((order) => order.clOrdID === payload.rejected.clOrdID)
      if (!order) return state

      const newOrder: LiveOrderType = {
        ...order,
        ordStatus: webSocket.order.status.REJECTED,
        text: payload.rejected.text
      }

      return {
        ...state,
        live: [
          ...state.live.filter((order) => order.clOrdID !== payload.rejected.clOrdID),
          newOrder
        ],
        subscribed: state.subscribed
      }
    }

    case AT.SET_MARGIN_DETAILS: {
      return { ...state, marginOrderDetails: action.payload }
    }

    case AT.SET_MARGIN_CALL_DETAILS: {
      return { ...state, marginCallDetails: action.payload }
    }

    case AT.SET_ACTIVE_POSITION: {
      return {
        ...state,
        activePosition: action.payload
      }
    }

    case AT.UPDATE_POSITION: {
      const newPosition = action.payload
      const positions = state.positions.find((p) => p.positionId === newPosition.positionId)
        ? state.positions.map((pos) =>
            pos.positionId === newPosition.positionId ? newPosition : pos
          )
        : [...state.positions, newPosition]
      return {
        ...state,
        positions
      }
    }

    default:
      return state
  }
}

export default order
